import React, { useState } from "react"
import ReactApexChart from "react-apexcharts"

// ✅ Utility to convert "HH:MM" or "MM:SS" strings to total minutes
const durationToMinutes = duration => {
  if (!duration) return 0
  const parts = duration.split(":").map(Number)
  if (parts.length === 2) {
    // MM:SS or HH:MM
    if (parts[0] > 23) {
      // assume MM:SS
      return parts[0] + parts[1] / 60
    } else {
      // assume HH:MM
      return parts[0] * 60 + parts[1]
    }
  } else if (parts.length === 3) {
    // HH:MM:SS
    return parts[0] * 60 + parts[1] + parts[2] / 60
  } else {
    const num = Number(duration)
    return isNaN(num) ? 0 : num
  }
}

const PieChart = ({ data, type = "duration", subtype = "planned" }) => {
  // ✅ Map and sanitize data
  const chartData =
    data?.map((item, index) => {
      let value = 0
      if (type === "duration") {
        value = durationToMinutes(item?.plannedDuration)
      } else if (type === "distance") {
        value = Number(item?.plannedDistance)
      }

      // ✅ Ensure NaN values are treated as 0
      if (isNaN(value)) value = 0

      return {
        value,
        color: ["#006d77", "#8338ec", "#ffb703", "#fb8500"][index % 4],
        label: item?.activityName || "Unknown",
        raw: item,
      }
    }) || []

  const series = chartData.map(item => item.value)
  const labels = chartData.map(item => item.label)
  const colors = chartData.map(item => item.color)

  const options = {
    chart: {
      type: "pie",
    },
    labels,
    colors,
    dataLabels: {
      enabled: true,
      formatter: (val, opts) =>
        `${labels[opts.seriesIndex]} ${val.toFixed(1)}%`,
    },
    legend: {
      position: "bottom",
    },
    tooltip: {
      custom: ({ series, seriesIndex }) => {
        const data = chartData[seriesIndex]
        return `
          <div style="padding: 10px; background-color: white; color: black; border-radius: 6px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
            <strong style="color:${data.color}; font-size: 14px;">${
          data.label
        }</strong><br/>
            <span><b>${subtype === "planned" ? "Planned" : "Completed"} ${
          type === "duration" ? "Duration" : "Distance"
        }:</b> ${
          type === "duration"
            ? (data.raw?.plannedDuration || "0:00") + " Hrs"
            : (data.raw?.plannedDistance || "0") + " Miles"
        }</span><br/>
          </div>
        `
      },
    },
  }

  return (
    <div className="position-relative">
      <ReactApexChart
        options={options}
        series={series}
        type="pie"
        height={250}
      />
    </div>
  )
}

export default PieChart
